import { render, staticRenderFns } from "./batchEditAds.vue?vue&type=template&id=6c499f61"
import script from "./batchEditAds.vue?vue&type=script&lang=js"
export * from "./batchEditAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports